import React from 'react';
import GIETextField from '../../components/GIETextField/GieTextField';
import {ValidatorForm} from 'react-material-ui-form-validator';
import {FormValidator} from '../../util/form-validator';
import GIEButton from '../../components/GIEButton/GieButton';
import InformationsController from '../../controller/informations.controller';
import GIECheckBox from '../../components/GIECheckBox/GieCheckBox';
import userInformations from '../../userInformation/user_informations';
import GIELink from "../GIELink/GIELink";

export default class MyCoordinateFormDetail extends React.Component<any, any> {
  formValidator: FormValidator = new FormValidator();
  informationsController: InformationsController = new InformationsController();

  constructor(props: any) {
    super(props);
    this.state = {
      isValid: true, initialFormControls: {}, formControls: {
        lastName: {
          value: '', error: false, errorMessage: ''

        }, email: {
          value: '', error: false, errorMessage: ''

        }, phoneNumber: {
          value: '', error: false, errorMessage: ''

        }, adresse: {
          value: '', error: false, errorMessage: ''

        }, zipCode: {
          value: '', error: false, errorMessage: ''

        }, city: {
          value: '', error: false, errorMessage: ''

        }, noClient: {
          value: '', error: false, errorMessage: ''

        }, noContract: {
          value: '', error: false, errorMessage: ''

        }, phoneMobile: {
          value: '', error: false, errorMessage: ''

        }, phoneHome: {
          value: '', error: false, errorMessage: ''

        }, phoneOffice: {
          value: '', error: false, errorMessage: ''

        }, confidentiality: {
          value: false, error: false, errorMessage: ''

        }
      }
    }
    this.checkValidForm = this.checkValidForm.bind(this);
  }

  componentDidMount() {
    const noContract = userInformations.getNoContract();
    if (!noContract?.length) {
      window.location.href = "/admin/login"
    } else {
      this.getData()
    }
  }

  getData = () => {
    this.informationsController.getUserInformations().then((data: any) => {
      this.setData(data)
    }).catch(err => {
      console.log(err)
    })
  }

  setData = (data) => {
    let formControls = this.state.formControls;
    formControls.lastName.value = data.user.name;
    formControls.email.value = data.user.email;
    formControls.phoneNumber.value = data.user.phone_no;
    formControls.adresse.value = data.user.address;
    formControls.zipCode.value = data.user.post_Code;
    formControls.city.value = data.user.city;
    formControls.noClient.value = data.user.no;
    formControls.noContract.value = userInformations.getNoContract();
    formControls.phoneMobile.value = data.user.mobile_phone_no;
    formControls.phoneHome.value = data.user.home_no;
    formControls.phoneOffice.value = data.user.office_No;
    let initialFormControls = JSON.parse(JSON.stringify(formControls));
    this.setState({formControls, initialFormControls})
  }

  checkValidForm = () => {
    let formControls = this.state.formControls;
    let isError = false;
    let nonRequiredFields = ['phoneMobile', 'phoneHome', 'phoneOffice', 'firstName'];
    if (this.props.confidentiality !== true) {
      nonRequiredFields = [...nonRequiredFields, 'confidentiality'];
    }
    Object.keys(formControls).forEach(name => {
      if (!nonRequiredFields.includes(name)) {
        const error = this.formValidator.returnError(formControls[name].value, name)
        formControls[name].error = error.error;
        formControls[name].errorMessage = error.errorMessage;
        if (error.error === true) {
          isError = true
        }
      }
    });
    this.setState({formControls, isError: isError})
    return isError;
  }

  addAsterisqueToChangedField = () => {
    let formControls = this.state.formControls
    Object.keys(formControls).forEach(name => {
      if (formControls[name].value !== this.state.initialFormControls[name].value) {
        formControls[name].value = '*' + formControls[name].value
      }
    });
    return formControls
  }

  handleSubmit = () => {
    const isError = this.checkValidForm();
    if (isError === false) {
      setTimeout(() => {
        const formControls = this.props.changed ? this.addAsterisqueToChangedField() : this.state.formControls;
        this.props.emit(formControls)
      }, 100);
    }
  }

  changeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const nonRequiredFields = ['phoneMobile', 'phoneHome', 'phoneOffice'];
    const error = nonRequiredFields.includes(name) ? {
      error: false, errorMessage: ''
    } : this.formValidator.returnError(value, name);
    this.setState({
      formControls: {
        ...this.state.formControls, [name]: {
          ...this.state.formControls[name], value, error: error.error, errorMessage: error.errorMessage
        }
      }
    });
  }

  checkCGV = (event) => {
    let formControls = this.state.formControls;
    formControls.confidentiality.value = !formControls.confidentiality.value
    this.setState({formControls})
  }

  render() {
    return (
      <div>
        <ValidatorForm
          ref="form"
          instantValidate={true}
          onSubmit={submit => console.log(submit)}
          onError={errors => console.log(errors)}>
          <GIETextField label="Nom du titulaire"
                        required
                        disabled
                        onChange={this.changeHandler}
                        name="lastName"
                        value={this.state.formControls.lastName.value}
                        helperText={this.state.formControls.lastName.errorMessage}
                        error={this.state.formControls.lastName.error}/>
          <GIETextField label="Votre email"
                        onChange={this.changeHandler}
                        name="email"
                        required
                        value={this.state.formControls.email.value}
                        helperText={this.state.formControls.email.errorMessage}
                        error={this.state.formControls.email.error}/>
          <GIETextField label="Votre n° de tel. principal"
                        required
                        onChange={this.changeHandler}
                        name="phoneNumber"
                        value={this.state.formControls.phoneNumber.value}
                        error={this.state.formControls.phoneNumber.error}
                        helperText={this.state.formControls.phoneNumber.errorMessage}/>
          {this.props.changed ? (<>
            <GIETextField label="Votre n° de mobile"
                          onChange={this.changeHandler}
                          name="phoneMobile"
                          value={this.state.formControls.phoneMobile.value}
                          helperText={this.state.formControls.phoneMobile.errorMessage}
                          error={this.state.formControls.phoneMobile.error}/>
            <GIETextField label="Votre n° professionnel"
                          onChange={this.changeHandler}
                          name="phoneOffice"
                          value={this.state.formControls.phoneOffice.value}
                          error={this.state.formControls.phoneOffice.error}
                          helperText={this.state.formControls.phoneOffice.errorMessage}/>
            <GIETextField label="Votre n° de domicile"
                          onChange={this.changeHandler}
                          name="phoneHome"
                          value={this.state.formControls.phoneHome.value}
                          error={this.state.formControls.phoneHome.error}
                          helperText={this.state.formControls.phoneHome.errorMessage}/>
          </>) : null}
          <GIETextField label="Adresse du site"
                        required
                        disabled
                        onChange={this.changeHandler}
                        name="adresse"
                        value={this.state.formControls.adresse.value}
                        error={this.state.formControls.adresse.error}
                        helperText={this.state.formControls.adresse.errorMessage}/>
          <GIETextField label="Vile du site"
                        required
                        disabled
                        onChange={this.changeHandler}
                        name="city"
                        value={this.state.formControls.city.value}
                        error={this.state.formControls.city.error}
                        helperText={this.state.formControls.city.errorMessage}/>
          <GIETextField label="Votre numéro de client"
                        required
                        onChange={this.changeHandler}
                        name="noClient"
                        value={this.state.formControls.noClient.value}
                        helperText={this.state.formControls.noClient.errorMessage}
                        aria-describedby="my-helper-text"
                        disabled
                        error={this.state.formControls.noClient.error}/>
          <GIETextField alone label="Votre numéro de contrat"
                        required
                        onChange={this.changeHandler}
                        name="noContract"
                        value={this.state.formControls.noContract.value}
                        helperText={this.state.formControls.noContract.errorMessage}
                        aria-describedby="my-helper-text"
                        disabled
                        error={this.state.formControls.noContract.error}/>
          {this.props.withButton !== false && (<>
            {this.props.confidentiality &&
                <GIECheckBox name="confidentiality"
                             errorText={this.state.formControls.confidentiality.errorMessage}
                             error={this.state.formControls.confidentiality.error}
                             isGrey
                             checked={this.state.formControls.confidentiality.value === true}
                             emit={(event) => this.checkCGV(event)}
                             label="En cochant cette case, j’accepte que mes données personnelles soient utilisées par GIE à des fins de traitement de ma demande."/>}
              <div className="text-center mt-4">
                <GIEButton onClick={this.handleSubmit}
                           classes={{root: 'blue-btn'}}>{this.props.buttonText}</GIEButton>
              </div>
          </>)}
          {this.props.offer && <div>
              <GIECheckBox checked={this.state.formControls.confidentiality.value === true}
                           name="confidentiality"
                           errorText={this.state.formControls.confidentiality.errorMessage}
                           error={this.state.formControls.confidentiality.error}
                           emit={(event) => this.checkCGV(event)}
                           label="En cochant cette case, j’accepte que mes données personnelles soient utilisées par GIE à des fins de traitement de ma demande"/>
              <div className="d-flex justify-content-between align-items-center mt-4">
                  <GIELink href="javascript:void(0)" onClick={this.props.previous} arrowBefore>Précédent</GIELink>
                  <GIEButton onClick={this.handleSubmit} classes={{root: 'blue-btn'}}>Suivant</GIEButton>
                  <div></div>
              </div>
          </div>}
        </ValidatorForm>
      </div>)
  }
}
